  <div class="tile-container" *ngIf="loaded">
    <div class="tile-header">
      <div class="tile-title">
        {{isDOR ? 'KPI' : 'Schedule'}}
      </div>
      <div class="refresh-container">
        <span *ngIf="lastRefreshed" class="last-refresh-time">Last Refresh: {{ lastRefreshed }}</span>
        <button class="refresh-button" title="Refresh" (click)="refresh()">
          <img src="/assets/home/refresh-tile-icon.svg" />
        </button>
      </div>
    </div>
    <ng-container *ngIf="!refreshing">
      <app-kpi *ngIf="isDOR"></app-kpi>
      <app-schedule *ngIf="!isDOR"></app-schedule>
    </ng-container>
  </div>
